import { render, staticRenderFns } from "./BCXMessengerChatBot.vue?vue&type=template&id=99705d9c&scoped=true"
import script from "./BCXMessengerChatBot.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerChatBot.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerChatBot.vue?vue&type=style&index=0&id=99705d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99705d9c",
  null
  
)

export default component.exports